// Tabs.jsx (drop-in)
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import * as S from '../../styled';

const Tabs = ({ tabKeys, activeTabKey, setActiveTabKey }) => {
  const { t } = useTranslation();

  return (
    <S.Tabs role="tablist" aria-label={t('search:common.title')} data-scroll-lock-ignore>
      {tabKeys.map((tabKey) => (
        <S.TabButton
          key={tabKey}
          type="button"
          role="tab"
          aria-selected={activeTabKey === tabKey}
          $active={activeTabKey === tabKey}
          onClick={() => setActiveTabKey(tabKey)}
        >
          {t(`search:common.tabs.${tabKey}`, tabKey)}
        </S.TabButton>
      ))}
    </S.Tabs>
  );
};

Tabs.propTypes = {
  tabKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTabKey: PropTypes.string.isRequired,
  setActiveTabKey: PropTypes.func.isRequired,
};

export default Tabs;
